import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { AutoSizer, Column, SortDirection, Table } from "react-virtualized";

const styles = theme => ({
  table: {
    fontFamily: theme.typography.fontFamily
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box"
  },
  tableRow: {
    cursor: "pointer",
    minHeight: '50px'
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: theme.palette.grey[200]
    }
  },
  tableCell: {
    flex: 1
  },
  noClick: {
    cursor: "initial",
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#fff',

    "&:hover": {
      backgroundColor: '#77c723'
    }
  },
  header: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#fff',
    "&:hover": {
      color: '#fff',
    },
    "&:active": {
      color: '#fff',
    },
    "&:focus": {
      color: '#fff',
    }
  },
  headerContainer: {
    backgroundColor: '#6da92e',
    justifyContent: 'center'
  },
  test: {
    backgroundColor: theme.palette.grey[100]
  }
});

function isEven(value) {
  if (value % 2 == 0)
    return true;
  else
    return false;
}

class MuiVirtualizedTable extends React.PureComponent {
  getRowClassName = ({ index }) => {
    const { classes, rowClassName, onRowClick } = this.props;

    return classNames(classes.tableRow, classes.flexContainer, rowClassName, {
      [classes.tableRowHover]: index !== -1 && onRowClick != null,
      [classes.test]: isEven(index) && 'test'
    });
  };

  cellRenderer = ({ cellData, columnIndex = null, width }) => {
    const { columns, classes, rowHeight, onRowClick } = this.props;

    return (
      <TableCell
        component="div"
        className={classNames(classes.tableCell, classes.flexContainer, {
          [classes.noClick]: onRowClick == null
        })}
        variant="body"
        style={{ height: rowHeight, width: width, fontSize: '14px', display: 'flex', justifyContent: 'center', textAlign: 'center' }}
        align="left"
      >
        {cellData}
      </TableCell>
    );
  };

  headerRenderer = ({ label, columnIndex, dataKey, sortBy, sortDirection, width }) => {
    const { headerHeight, columns, classes, sort } = this.props;

    const direction = {
      [SortDirection.ASC]: "asc",
      [SortDirection.DESC]: "desc"
    };

    const inner =
      !columns[columnIndex].disableSort && sort != null ? (
        <TableSortLabel
          active={dataKey === sortBy}
          direction={direction[sortDirection]}
          onClick={sort}
          className={classNames(classes.header)}
        >
          {label}
        </TableSortLabel>
      ) : (
        label
      );

    return (
      <TableCell
        component="span"
        className={classNames(
          classes.tableCell,
          classes.flexContainer,
          classes.noClick
        )}
        variant="head"
        style={{ height: headerHeight, width: width, justifyContent: 'center' }}
        align="center"
      >
        {inner}
      </TableCell>
    );
  };

  render() {
    const { classes, columns, ...tableProps } = this.props;
    return (
      <AutoSizer>
        {({ height, width }) => {
          let initialWidth = width;
          let collWithoutWidth = 0;

          columns.forEach(i=> {
            if (i.cWidth) {
              initialWidth = initialWidth - i.cWidth;
            } else {
              collWithoutWidth += 1;
            }
          });

          return (
            <Table
              className={classes.table}
              height={height}
              width={width}
              {...tableProps}
              rowClassName={this.getRowClassName}
              headerClassName={classes.headerContainer}
            >
              {columns.map(
                (
                  { cellContentRenderer = null, className, dataKey, cWidth, ...other },
                  index
                ) => {
                  let renderer;
                  if (cellContentRenderer != null) {
                    renderer = cellRendererProps =>
                      this.cellRenderer({
                        cellData: cellContentRenderer(cellRendererProps),
                        columnIndex: index,
                        width
                      });
                  } else {
                    renderer = this.cellRenderer;
                  }

                  return (
                    <Column
                      width={cWidth ? cWidth : initialWidth / collWithoutWidth }
                      key={dataKey}
                      headerRenderer={headerProps =>
                        this.headerRenderer({
                          ...headerProps,
                          columnIndex: index,
                          width: cWidth ? cWidth : initialWidth / collWithoutWidth
                        })
                      }
                      className={classNames(classes.flexContainer, className)}
                      cellRenderer={renderer}
                      dataKey={dataKey}
                      {...other}
                    />
                  );
                }
              )}
            </Table>
          )
        }}
      </AutoSizer>
    );
  }
}

MuiVirtualizedTable.defaultProps = {
  headerHeight: 56,
  rowHeight: 56
};

const WrappedVirtualizedTable = withStyles(styles)(MuiVirtualizedTable);
export default WrappedVirtualizedTable;
